import _ from 'lodash';
import { useSearchParams } from "react-router-dom";
import { APPNAME } from '../constants';

export const useAppName = (str: string) => {
    const [param] = useSearchParams();
    return _.isEqual(param.get(APPNAME), str);
}
